import React from 'react';
import { StyledAddTab } from './styles';

export const AddTab = ({ onClick }) => {
  return (
    <>
      <StyledAddTab
        onClick={() => {
          onClick();
        }}
      >
        +
      </StyledAddTab>
    </>
  );
};
